exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-editor[data-v-d92a189c] .modal-header h5{line-height:24px}.image-editor .body[data-v-d92a189c]{margin-top:-1rem;margin-bottom:-1rem;height:500px}.image-editor .body .upload-area[data-v-d92a189c]{border-left:1px solid #e9ecef}.image-editor .body .crop-area[data-v-d92a189c],.image-editor .body .upload-area[data-v-d92a189c]{transition:flex-basis .15s ease-out,max-width .15s ease-out}.image-editor .body.no-image .crop-area[data-v-d92a189c]{flex-basis:0;max-width:0}.image-editor .body.no-image .upload-area[data-v-d92a189c]{flex-basis:100%;max-width:100%;border-left:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d92a189c","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Components/ImageEditor.vue
// module id = 1173
// module chunks = 6